import { Props } from '@components/toggle/src/toggle-button.type';
import classNames from 'classnames';

export const ToggleButton = ({ children, enabled, setEnabled, disabled, ...props }: Props) => {
  const handleClick = () => {
    if (!disabled) {
      setEnabled();
    }
  };

  return (
    <button
      type='button'
      className={classNames(
        'inline-flex items-center px-6 py-3 rounded-full border-0 text-subtitle-m transition duration-200 ease-in-out focus:ring-0 lg:px-10',
        {
          'text-primary fill-primary': enabled && !disabled,
          'text-secondary fill-primary-active': !enabled,
          'fill-primary-disabled': enabled && disabled,
          'cursor-not-allowed pointer-events-none text-transparent-20': disabled,
        }
      )}
      onClick={handleClick}
      {...props}>
      {children}
    </button>
  );
};
